import { PATH_E360 } from "@/constants/URL";

import routerWithSidebar from "./routerWithSidebar";

export default {
  path: PATH_E360,
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: PATH_E360,
      name: "e360",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/e360/up.vue")
      )
    }
  ]
};
